export default __webpack_public_path__ + "static/media/attendance-outline-16px.1b6a497e.svg";